import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

export const useAddIncidenceValidationSchema = () => {
  const { t } = useTranslation();

  return useMemo(
    () =>
      Yup.object({
        // Solo en modo edición.
        title: Yup.string().matches(
          /^[^<>]*$/,
          t('pages.incidents.titleInvalidCharacters'),
        ),

        description: Yup.string()
          .trim()
          .required(t('pages.incidents.descriptionRequired'))
          .max(4000, t('pages.incidents.descriptionTooLong'))
          .matches(
            /^[^<>]*$/,
            t('pages.incidents.descriptionInvalidCharacters'),
          ),

        start_time: Yup.date()
          .nullable()
          .typeError(t('pages.incidents.dateRequired'))
          .required(t('pages.incidents.dateRequired')),

        // El dispositivo seleccionado aporta serial_number al DTO.
        d_id: Yup.string().required(t('pages.incidents.d_idRequired')),

        // Catálogos de RPS: se envía el id, no el texto.
        type: Yup.string().required(t('pages.incidents.type_1Required')),
        severity: Yup.string().required(t('pages.incidents.impactRequired')),
        priority: Yup.string().required(t('pages.incidents.priorityRequired')),
        detection: Yup.string().required(
          t('pages.incidents.detectionRequired'),
        ),
        communication_channel: Yup.string().required(
          t('pages.incidents.communicationChannelRequired'),
        ),

        detected_by: Yup.string()
          .required(t('pages.incidents.detectedByRequired'))
          .max(255),
      }),
    [t],
  );
};